export default __webpack_public_path__ + "static/media/humanResourcesModule.9533c19a.svg";